import { FormItem, NumberInput } from '@framework/form';
import { RowElement } from '@framework/ui';
import React from 'react';
import { $SpaceCompact } from '../../../../ui/form/SpaceCompact';
import { RuleType } from '../../IRule';
import type { IRuleConfigComponentProps } from '../../IRuleType';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage';

const fieldName = `rules.${RuleType.LengthRange}`;

export function LengthRangeRuleComponent(props: IRuleConfigComponentProps) {
  return (
    <RowElement>
      <FormItem
        name={`${fieldName}.min`}
        label="Lunghezza minima"
        help="La lunghezza inserita si considera inclusa."
      >
        <$SpaceCompact block size="large">
          <NumberInput name={`${fieldName}.min`} />
          <CustomValidationRuleMessage name={`${fieldName}.minCustomMessage`} />
        </$SpaceCompact>
      </FormItem>
      <FormItem
        name={`${fieldName}.max`}
        label="Lunghezza massima"
        help="La lunghezza inserita si considera inclusa."
      >
        <$SpaceCompact block size="large">
          <NumberInput name={`${fieldName}.max`} />
          <CustomValidationRuleMessage name={`${fieldName}.maxCustomMessage`} />
        </$SpaceCompact>
      </FormItem>
    </RowElement>
  );
}
